import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { JwtService } from 'app/auth/jwt.service';
import { environment } from 'environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SitemateApiService {
  constructor(private readonly httpClient: HttpClient, private readonly jwtService: JwtService) {}

  uploadSignature<T = any>(file: File): Observable<T> {
    const url = `${environment.global.apiUrl}/user/upload`;
    const formData = new FormData();
    formData.append('type', 'signature');
    formData.append('files', file);

    const headers$ = from(this.getJwtHeaders());

    return headers$.pipe(
      switchMap((headers) => {
        return this.httpClient.post<T>(url, formData, { headers });
      }),
    );
  }

  private async getJwtHeaders(): Promise<{ Authorization: string; Authtype: string }> {
    return {
      Authorization: await this.jwtService.getToken(),
      Authtype: 'fusionauth',
    };
  }
}
